import { render } from "./PoliticasNegociacao.vue?vue&type=template&id=5f0e9b14&scoped=true"
import script from "./PoliticasNegociacao.vue?vue&type=script&lang=js"
export * from "./PoliticasNegociacao.vue?vue&type=script&lang=js"

import "./PoliticasNegociacao.vue?vue&type=style&index=0&id=5f0e9b14&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0e9b14"]])

export default __exports__